export const USER_ENDPOINTS = {
  GET_USERS: '/user/list',
  GET_APPROVERS: '/v1.1/api-bills/dropdown/approvers/',
  GET_USER_DATA: '/user/user_data/',
};

export const ASSIGNED_BILL_ENDPOINTS = {
  GET_ASSIGNED_BILL: '/bills/dropdown/bills/',
};

export const GLOBAL_ENDPOINTS = {
  COUNTRY: '/mobile/supplier/country/',
  STATE: '/state/',
  SAVE_ATTACHMENT: '/attachment/save_attachment/',
};

export const GUEST_USER_ENDPOINTS = {
  SEND_GUEST_OTP: '/v1.1/user/send_guest_otp/',
  VERIFY_GUEST_OTP: '/v1.1/user/verify_guest_otp/',
  ONBOARD_NEW_GUEST_USER: '/v1.1/user/complete_guest_onboarding/',
};

export const MY_APPROVAL_COUNTS_ENDPOINTS = {
  MY_APPROVAL_COUNTS: '/my_approval_counts/',
};
